import { ArrowUp, ArrowDown } from "lucide-react";

export default function AdminStatCard({ icon: Icon, label, value, trend, sub, trendDir }) {
  return (
    <div
      className="px-5 py-4 bg-white border border-neutral-100 rounded-xl"
      style={{ boxShadow: "0 1px 3px rgba(17,24,39,.08)" }}
    >
      <div className="flex items-center gap-1.5 mb-3">
        {Icon && <Icon size={12} className="text-neutral-400" strokeWidth={2} />}
        <span className="text-[11px] font-semibold text-neutral-400 uppercase tracking-[.07em]">{label}</span>
      </div>
      <div className="text-[28px] font-bold text-neutral-900 tracking-tight leading-none tabular-nums mb-2">
        {value}
      </div>
      {trend && (
        <div className="flex items-center gap-1">
          <span
            className="inline-flex items-center gap-0.5 text-[11px] font-semibold"
            style={{ color: trendDir === "up" ? "#16a34a" : trendDir === "down" ? "#dc2626" : "#6b7280" }}
          >
            {trendDir === "up" && <ArrowUp size={10} strokeWidth={2.5} />}
            {trendDir === "down" && <ArrowDown size={10} strokeWidth={2.5} />}
            {trend}
          </span>
        </div>
      )}
      {sub && <div className="text-[11px] text-neutral-400 mt-0.5">{sub}</div>}
    </div>
  );
}